<template>
  <v-app id="app" dark>
    <MainMenu/>
    <router-view></router-view>
    <MainFooter></MainFooter>
  </v-app>
</template>

<script>
import MainMenu from "./components/MainMenu";
import MainFooter from "./components/MainFooter";
export default {
  components: { MainFooter, MainMenu },
  props: {
    source: String
  }
};
</script>

<style lang="stylus">
@import '~vuetify/src/stylus/main';
#app
  font-family 'Avenir', Helvetica, Arial, sans-serif

#nav
  padding 30px
  a
    font-weight bold
    color #2c3e50
    &.router-link-exact-active
      color #42b983
</style>
